"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../hooks/useField");
var common_1 = require("./common");
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var utilityTypes_1 = require("../../util/utilityTypes");
var Wrapper = (0, styled_components_1.default)(common_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  padding-right: ", "px;\n  flex-shrink: ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  padding-right: ", "px;\n  flex-shrink: ", ";\n"])), function (p) { return (p.hasIcon ? common_1.fieldHeight : 0); }, function (p) { return (p.shrink ? 1 : 0); });
var PlaceholderWithIcon = (0, styled_components_1.default)(common_1.Placeholder)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  right: ", "px;\n"], ["\n  right: ", "px;\n"])), function (p) { return (p.hasIcon ? common_1.fieldHeight : 0); });
var TextFieldBorder = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: ", ";\n  border-radius: 8px;\n"], ["\n  border: ", ";\n  border-radius: 8px;\n"])), function (p) {
    return p.entryType === "input" && p.currentHost === utilityTypes_1.Theme.LivaNova
        ? "2px solid ".concat(p.theme.oldColors.shade[8])
        : "2px solid transparent";
});
var Label = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var Hint = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 0.8em;\n  margin-left: 0.3em;\n  position: relative;\n  top: 0.1em; // adjusts alignment with Label\n"], ["\n  font-size: 0.8em;\n  margin-left: 0.3em;\n  position: relative;\n  top: 0.1em; // adjusts alignment with Label\n"])));
var TextField = function (props) {
    var label = props.label, hint = props.hint, icon = props.icon, _a = props.type, type = _a === void 0 ? "text" : _a, disabled = props.disabled, shrink = props.shrink, background = props.background, _b = props.entryType, entryType = _b === void 0 ? "default" : _b, _c = props.currentHost, currentHost = _c === void 0 ? utilityTypes_1.Theme.Epsy : _c;
    var _d = (0, useField_1.useField)(props), field = _d[0], meta = _d[1];
    var error = meta.error, touched = meta.touched;
    var showError = Boolean(error && touched);
    var placeholderEl = field.value ? null : (react_1.default.createElement(PlaceholderWithIcon, { hasIcon: !!icon },
        react_1.default.createElement(Label, null, label),
        hint ? react_1.default.createElement(Hint, null,
            "(",
            hint,
            ")") : null));
    var inputEl = react_1.default.createElement(common_1.TextInput, __assign({}, field, { type: type, disabled: disabled }));
    var iconEl = icon ? react_1.default.createElement(common_1.IconWrapper, null, icon) : null;
    var textBoxBackgroundColor = (type === "text" || type === "password") && currentHost === utilityTypes_1.Theme.LivaNova
        ? common_1.boxBackgrounds[1]
        : common_1.boxBackgrounds[0];
    // Removed the underline highlighter based on new Login design
    // const lineEl = disabled ? null : <Line hasError={showError} />
    var errorEl = showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextFieldBorder, __assign({}, { entryType: entryType, currentHost: currentHost, hasError: showError }),
            react_1.default.createElement(Wrapper, { hasIcon: !!icon, shrink: shrink, background: textBoxBackgroundColor || background },
                placeholderEl,
                inputEl,
                iconEl)),
        errorEl));
};
exports.default = TextField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
